/*
 * @Author: jy
 * @说明：消息相关接口地址
 */

// 获取消息列表
export const noticeList = '/index/notice/list'
// 获取详情
export const noticeDetail = '/index/notice/get-notice-info'



// WEBPACK FOOTER //
// ./src/api/url/notice.js